import refreshCart, { sectionsRendering } from './refreshCart';
import handleError from './handleError';
import cartCookies from './cartCookies';
import interactionBlocker from './interactionBlocker';
import { getSectionsToRenderByPDP, getSectionsToRenderByAdd } from './cartSections';
import cartAddTracking from './cartTracking';

document.addEventListener('variantUpdatedForm', (e) => {
  const { variantId, parent } = e.detail;

  const form = parent.querySelector('form[action="/cart/add"]');

  if (form) {
    const idField = form.querySelector('[name="id"]');
    if (idField) {
      idField.value = variantId;
    }
  }
});

export default async function (form) {
  // Retrieve the product JSON data
  let productJson;
  // Check if the form came in a Quick View modal. Down below we will remove the quick view content to prevent any issue
  let quickView = document.querySelector('[data-quick-view-container]');
  // Check if the form came from an Shoppable item.
  let shoppableProduct = form.closest('div[data-shoppable-product]');
  if (quickView) {
    productJson = JSON.parse(
      form.closest('.QuickView__content[data-section-type="product"]').querySelector('[data-product-json]').innerHTML,
    );
  } else if (shoppableProduct) {
    // Get the product json object that it is associated to this shoppable item
    productJson = JSON.parse(shoppableProduct.querySelector('[data-product-json]').innerHTML);
  } else {
    productJson = JSON.parse(form.querySelector('[data-product-json]').innerHTML);
  }

  // Prepare data: The data from a HTML form will be converted to FormData
  const preparedData = new FormData(form);
  // Final data
  const formData = new FormData();

  // Shopify AJAX needs a structure like items[0][id], items[0][quantity] for working properly
  // more info here: https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js
  for (const [key, value] of preparedData) {
    formData.append(`items[0][${key}]`, value);
  }
  // Add item quantity, it's optional in a FormData request payload for Shopify AJAX API
  // but we want to ancipate any breaking change from Shopify if it is required in the future
  formData.append('items[0][quantity]', 1);

  let getSectionsToRender;
  if (window.location.pathname !== '/cart') {
    getSectionsToRender = getSectionsToRenderByPDP();
  } else {
    getSectionsToRender = getSectionsToRenderByAdd();
  }

  formData.append('sections', getSectionsToRender.map((section) => section.section).join(','));

  // Define a sections_url attribute for the AJAX request if the current page is not the cart page, i.e. PLP, PDP, etc.
  // This will allow Shopify to return the updated sections, specially cart-atb with product data in the response
  // according to the product added to the cart
  if (window.location.pathname !== '/cart') {
    formData.append('sections_url', `/products/${productJson.handle}`);
  }

  try {
    const responseAddItem = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    });

    // Check if the response was successful
    if (!responseAddItem.ok) {
      const errorData = await responseAddItem.json();
      const error = new Error('Cart network fecth response was not ok');
      error.details = errorData;
      throw error;
    }

    const dataAddedItem = await responseAddItem.json();

    // Updates cart-atb and cart-indicator sections if the current page is not the cart page
    // Otherwise, it updates cart-header, cart-shipping, cart-totals, cart-icon-bubble, and cart-items
    sectionsRendering(dataAddedItem.sections, { cartItemKey: dataAddedItem.items[0].key });
    if (window.location.pathname !== '/cart') {
      const atbModal = document.querySelector('add-to-bag');
      atbModal && atbModal.openModal();
      atbModal && atbModal.closeModal();
    }
    // Interaction blocker: unblock cart
    interactionBlocker();
    // Defer this block of code because they are no user-visible tasks
    setTimeout(async () => {
      // Define the quantity and item data for the event
      let quantity = dataAddedItem.quantity;
      let variantId = formData.get('items[0][id]');
      let itemData = {
        quantity,
        productJson,
        variantId,
      };

      // Call GET "cart.js" for getting the current cart state afterwards we have added a new item
      // because of lack of cart data from POST "add.js"
      const responseGetCart = await fetch('/cart.js');
      // Check if the response was successful
      if (!responseGetCart.ok) {
        const errorData = await responseGetCart.json();
        const error = new Error('Network response was not ok');
        error.details = errorData;
        throw error;
      }

      // Provide sections to cart data which was gotten from POST "add.js" and it already updated
      const cartData = await responseGetCart.json();
      cartData.sections = dataAddedItem.sections;

      // Handle cart cookies if necessary
      cartCookies(form);

      // Edge-case: If customer add item to the cart from a Quick View modal on PDP
      // Once you add an item to the cart from quick view modal, the quick view content should be removed
      // it will guarantee you can add another item to the cart from PDP without any issue
      if (window.location.pathname !== '/cart' && quickView) {
        document.querySelector('[data-quick-view-content]').innerHTML = ''; // remove the quick view content
      }

      // Refresh the cart sections and trigger a custom add item event with itemData object as detail
      refreshCart(cartData, { name: 'addItem', detail: itemData, quickView }, false);

      // Trigger Add to Cart event from different Third-Party Application such as Fast Simon, etc.
      cartAddTracking(cartData, form);

      // Reset all input fields (text, textarea, email, etc.) in form. Specially, ones are in gift-card form.
      form.reset();
    }, 0);
  } catch (error) {
    // Interaction blocker: unblock cart
    interactionBlocker();
    console.error('Cart error:', error);
    if (error.details) {
      console.error('Error details:', error.details);
    }
    handleError(error.details.message);
  }
}
